import { HttpHelper } from "@/helper/HttpHelper";
import Cookies from 'js-cookie';

const getToken = () =>
    Cookies.get('token') ||
    (typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null);

// Get Following List API
export const getFollowingListAPI = async () => {
    const token = getToken();
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/authors/following';
    const response = await HttpHelper.get(apiUrl, { headers }).then((response) => response.data);
    return response;
}

// Get Followers List API
export const getFollowersListAPI = async () => {
    const token = getToken();
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/authors/followers';
    const response = await HttpHelper.get(apiUrl, { headers }).then((response) => response.data);
    return response;
}

// Follow API
export const followAPI = async (request) => {
    const { authorId } = await request;
    const token = getToken();
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const body = {
        author_id: authorId,
    }
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/authors/follow';
    const response = await HttpHelper.post(apiUrl, body, { headers }).then((response) => response.data);
    return response;
}

// Save an article API
export const saveArticleAPI = async (request) => {
    const { articleId } = await request;
    const token = getToken();
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const body = {
        article_id: articleId,
    }
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/saved-articles/toggle';
    const response = await HttpHelper.post(apiUrl, body, { headers }).then((response) => response.data);
    return response;
}

// Like UnLike Article API
export const likeUnLikeArticleAPI = async (request) => {
    const { articleId } = await request;
    const token = getToken();
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const body = {
        article_id: articleId,
    }
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/article-likes/toggle';
    const response = await HttpHelper.post(apiUrl, body, { headers }).then((response) => response.data);
    return response;
}

// Get Article Likes List API
export const getArticleLikesListAPI = async (request) => {
    const { articleId } = request;
    const token = getToken();
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/article-likes/liked';
    const response = await HttpHelper.get(apiUrl, {
        headers,
        params: {
            article_id: articleId,
        },
    }).then((response) => response.data);
    return response;
}

// Get Comments API
export const getCommentsAPI = async (request) => {
    const { articleId, per_page, page } = request;
    const token = getToken();
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/comments';
    const response = await HttpHelper.get(apiUrl, {
        headers,
        params: {
            article_id: articleId,
            ...(per_page != null && { per_page }),
            ...(page != null && { page }),
        },
    }).then((response) => response.data);
    return response;
}

// Save Comment API
export const saveCommentAPI = async (request) => {
    const { articleId, commentText } = request;
    const token = getToken();
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const body = {
        article_id: articleId,
        comment: commentText,
    }
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/comments';
    const response = await HttpHelper.post(apiUrl, body, { headers }).then((response) => response.data);
    return response;
}

// Save Article By User API
export const saveArticleByUserAPI = async (request) => {
    const { articleId } = request;
    const token = getToken();
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/saved-articles/saved';
    const response = await HttpHelper.get(apiUrl, {
        headers,
        params: {
            article_id: articleId,
        },
    }).then((response) => response.data);
    return response;
}

// Saved Article API
export const savedArticleAPI = async (request) => {
    const { articleId } = request;
    const token = getToken();
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/saved-articles/toggle';
    const body = {
        article_id: articleId,
    }
    const response = await HttpHelper.post(apiUrl, body, { headers }).then((response) => response.data);
    return response;
}